import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom'

export default function Redirect() {

    // const RedirectPage = () => {
    //     useEffect(() => {
    //       window.location.replace('https://www.kindacode.com');
    //     }, [])
    window.location.replace('https://google.com');

    return null
}
